import {
  Box,
  Typography,
  useTheme,
  TextField,
  Grid,
  IconButton,
} from "@mui/material";
import { useState } from "react";
import Header from "../../components/Header";
import { SearchOutlined } from "@mui/icons-material";
import data from "./data.json";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  iconButtonHover: {
    position: "relative",
    "&:hover": {
      backgroundColor: "#ADD8E6",
      //#ADD8E6
      borderRadius: "10%",
    },
  },
}));

const TokenGating = () => {
  const theme1 = useTheme();
  const navigate = useNavigate();
  const [filteredData, setFilteredData] = useState(data);
  const [wordEntered, setWordEntered] = useState("");
  const classes = useStyles(theme1);
  const handleFilter = (event) => {
    const searchWord = event.target.value;
    setWordEntered(searchWord);
    const newFilter = data.filter((value) => {
      return value.title.toLowerCase().includes(searchWord.toLowerCase());
    });
    setFilteredData(newFilter);
  };
  const handleSelectedApp = (title) => {
    if (title === "Google drive") {
      navigate("/token-gating/google-drive");
    } else if (title === "Discord") {
      navigate("/token-gating/discord");
    } else if (title == "Circle") {
      navigate("/token-gating/circle");
    } else if(title == "Calendly"){
      navigate("/token-gating/calendly")
    } else if(title == "Discourse"){
      navigate("/token-gating/discourse")
    } else if(title == "Zoom"){
      navigate("/token-gating/zoom")
    } else if(title == "Skool"){
      navigate("/token-gating/skool")
    } else if (title === "Shopify") {
      window.open("https://apps.shopify.com/web3-login-nft-token-gating");
    } else if (title === "WordPress") {
      window.open("https://wordpress.org/plugins/web3-authentication/");
    } else {
      setWordEntered(title);
      setFilteredData([]);
      navigate("/token-gating/customization", { state: title });
    }
  };
  return (
    <Box m="20px">
      <Header
        title="Token Gating"
        subtitle="Select the preferred app for which you want to apply Token Gating"
      />
      <Box component="form" noValidate>
        <Grid container rowSpacing={2} columnSpacing={2} sx={{ mt: 2 }}>
          <Grid item md={12} xs={12} sm={12} style={{ marginRight: "4%" }}>
            <TextField
              sx={{
                mb: 3,
                mt: 2,
                backgroundColor: "white",
                boxShadow: "2",
                borderRadius: "4%",
              }}
              fullWidth
              value={wordEntered}
              onChange={handleFilter}
              label="Search for apps....."
              InputProps={{
                endAdornment: (
                  <IconButton>
                    <SearchOutlined />
                  </IconButton>
                ),
              }}
            />
          </Grid>

          <Grid container direction={{ xs: "column", md: "row", sm: "row" }}>
            {filteredData.map((value, key) => {
              return (
                <Grid key={key} sx={{ mb: 2 }}>
                  <IconButton
                    sx={{ ml: 2 }}
                    className={classes.iconButtonHover}
                    onClick={() => handleSelectedApp(value.title)}
                  >
                    <Box
                      variant="gradient"
                      shadow="lg"
                      opacity={3}
                      p={2}
                      textAlign="left"
                      sx={{
                        boxShadow: 4,
                        borderRadius: "10%",
                        backgroundColor: "white",
                      }}
                    >
                      <img
                        alt=""
                        width={85}
                        height={85}
                        style={{ objectFit: "contain" }}
                        src={require(`./images/${value.imageLink}`)}
                      />
                    </Box>
                  </IconButton>

                  <Typography
                    align="center"
                    sx={{
                      color: "rgb(0, 104, 74)",
                      fontFamily: "Poppins",
                      ml: 2,
                    }}
                  >
                    {value.title}
                  </Typography>
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default TokenGating;
